module.exports = "<div class=\"checkbox-container\">\r\n  <div  [id]=\"checkboxId\" class=\"checkbox\" (click)=\"onClick()\" [ngClass]=\"{ selected: isSelected }\" role=\"checkbox\" [attr.aria-checked]=\"isSelected\" [tabindex]=\"isEnable ? '0' : '-1'\" (focus)=\"onFocus($event)\"></div>                     \r\n  <label [for]=\"checkboxId\" class=\"checkbox-text\" (click)=\"onClick()\" *ngIf=\"text\" >{{ text }}</label>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/chckbox/chckbox.component.html
// module id = ../../../../../src/app/core/components/chckbox/chckbox.component.html
// module chunks = main